import { View, ViewModel } from "binder"
import { TabItemContainerViewModel } from "./tabItemContainer-viewModel";

export class TabItemBodyView extends View<TabItemContainerViewModel>{
    GetViewUniqueId(): string {
        return "V-61D06FA6-55BC-460B-AD65-968E35CE8CD5"
    }
    loadHtml(): string {
        let element = require('./tabItemBody.html').default;
        let style = require('./tabItemBody.less');
        return element;
    }
    constructor() {
       super();
    }
    public set element(v: ViewModel) { this._element = v; } public get element(): ViewModel { return this._element;} private _element: ViewModel;
    public set isselected(v: boolean) { this._isselected = v; } public get isselected(): boolean { return this._isselected;} private _isselected: boolean;

}
